import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { AppRoutes } from "src/app/navigation/routes";
import { useAppSelector } from "src/app/services/store";
import {
  EyengageIcon,
  HomeIcon,
  MenuBarIcon,
  MessageIcon,
  TimelineIcon,
} from "src/app/static/images/svg";
import { checkIsEylogOnlyNursery } from "src/app/utilities/helpers";
import { getCurrentChild } from "src/shared/redux-state/src";
import { ChildrenStoreData } from "src/shared/types/src";

const TabNavigation = () => {
  const [isEylogOnlyNursery, setIsEylogOnlyNursery] = useState<boolean>(false);
  const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

  useEffect(() => {
    setIsEylogOnlyNursery(checkIsEylogOnlyNursery(currentChild));
  }, [currentChild.childInstanceKey]);

  return (
    <div className="tab-navigation">
      <ul>
        <li>
          <NavLink
            to={AppRoutes.HOME}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <HomeIcon />
            <span>Home</span>
          </NavLink>
        </li>
        <li>
          <NavLink to={AppRoutes.EYENGAGE}>
            <EyengageIcon />
            <span>Newsfeed</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to={AppRoutes.TIMELINE}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <TimelineIcon />
            <span>Timeline</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to={
              isEylogOnlyNursery
                ? AppRoutes.EYLOG_MESSAGES
                : AppRoutes.COMMUNICATIONS
            }
            className={({ isActive }) =>
              isActive ||
              [
                AppRoutes.COMMUNICATIONS,
                AppRoutes.CONVERSATIONS,
                AppRoutes.EYLOG_MESSAGES,
              ].some((route) => window.location.pathname.includes(route))
                ? "active"
                : ""
            }
          >
            <MessageIcon />
            <span>Messages</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to={AppRoutes.OPTIONS}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <MenuBarIcon />
            <span>Menu</span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default TabNavigation;
